/* eslint-disable @typescript-eslint/no-explicit-any */
type EventHandler<E> = ((event: E) => void | Promise<void>) | undefined | null;

/**
 * Merges multiple event handlers into a single handler that executes them in sequence
 * @param handlers - Array of event handlers to merge
 * @returns A single event handler that executes all provided handlers
 */
export function mergeEvents<E>(...handlers: EventHandler<E>[]) {
  return async (event: E) => {
    // Create a copy of the event since it might be reused
    const eventCopy = { ...event } as E;

    // Preserve the original preventDefault behavior if it exists
    const originalPreventDefault = (event as any).preventDefault?.bind(event);

    // Keep track if preventDefault was called
    let defaultPrevented = false;
    if (originalPreventDefault) {
      (event as any).preventDefault = () => {
        defaultPrevented = true;
        originalPreventDefault();
      };
    }

    // Execute all handlers in sequence
    for (const handler of handlers) {
      if (handler) {
        try {
          await handler(eventCopy);
        } catch (error) {
          console.error("Error in event handler:", error);
        }
      }
    }

    // If any handler called preventDefault, ensure it's called on the original event
    if (defaultPrevented) {
      originalPreventDefault();
    }
  };
}
